function navController($scope, taskStorage, filterFilter) {
  var tasks;
  tasks = $scope.tasks = taskStorage.get();
  $scope.taskRemainingCount = filterFilter(tasks, {
    completed: false
  }).length;
  return $scope.$on('taskRemaining:changed', function (event, count) {
    return $scope.taskRemainingCount = count;
  });
}

angular
  .module('app.controllers')
  .controller(
    'NavCtrl', [
      '$scope', 'taskStorage', 'filterFilter',
      navController
    ]
  );



// WEBPACK FOOTER //
// ./scripts/shared/controllers/nav.js